module.exports = __webpack_public_path__ + "img/the-netherlands-external-causes-male.ff0dc57e.png";